'use client';

import type { LeadFormSuccessPayload, ModelType } from '@/app/api/lms/type';
import { LeadForm } from '@/app/components/form-kit/lead-form';
import { useModalStateResult } from '@/app/components/sections/register/modals/hooks/useModalStateResult';
import { ModalStatusResult } from '@/app/components/sections/register/modals/modal-status-result';
import { createLeadFormSchema } from '@/app/lib/forms/schemas/lead-form.schema';
import type { LeadFormTrackingConfig } from '@/app/lib/forms/tracking/types';
import type { ProvinceWithDistrictsType } from '@/app/types/form';

interface RegisterFormProps {
  fbModel?: string;
  formId: string;
  formName: string;
  campaignVersion?: string;
  provinces: ProvinceWithDistrictsType[];
  buttonLabel?: string;
  redirectToHome?: boolean;
  model?: ModelType;
  remark?: string;
  formTracking?: LeadFormTrackingConfig;
  onLeadSuccess?: (payload: LeadFormSuccessPayload) => Promise<void> | void;
}

export const RegisterForm = ({
  formId = '',
  formName = '',
  campaignVersion = '1',
  fbModel,
  provinces = [],
  model,
  remark = '',
  buttonLabel,
  redirectToHome = true,
  formTracking,
  onLeadSuccess,
}: RegisterFormProps) => {
  const { modalState, handleSuccess, handleError, onClose } =
    useModalStateResult();

  const handleLeadSuccess = (payload?: LeadFormSuccessPayload) => {
    if (payload && onLeadSuccess) {
      void onLeadSuccess(payload);
    }
    handleSuccess();
  };

  return (
    <>
      <LeadForm
        fbModel={fbModel}
        formLayout="two-column"
        formId={formId}
        formName={formName}
        campaignVersion={campaignVersion}
        model={model}
        schema={createLeadFormSchema()}
        provinces={provinces || []}
        remark={remark}
        formTracking={formTracking}
        onSuccess={handleLeadSuccess}
        onError={handleError}
      />
      <ModalStatusResult
        modalState={modalState}
        onClose={onClose}
        okButtonLabel={buttonLabel}
        redirectToHome={redirectToHome}
      />
    </>
  );
};
